<template>
  <layout name="Sidebar">
    <div class="support">
      <h1 class="title">How can we help ?</h1>
      <div class="support__types">
        <div
          v-for="type in reportTypes"
          class="type-item"
          @click="
            navigate({
              name: 'support-form',
              query: { type: type.key }
            })
          "
          @mouseover="submitBtnHovered = type.key"
          @mouseleave="submitBtnHovered = false"
          :class="{ ['hovered']: submitBtnHovered === type.key }"
        >
          <img class="image" :src="type.image" />
          <h2 class="title">{{ type.title }}</h2>
          <pre class="description">{{ type.description }}</pre>
          <div
            class="submitBtn"
            :class="{ ['hovered']: submitBtnHovered === type.key }"
          >
            <span>Open a Case</span><img :src="chooseArrow(type.key)" />
          </div>
        </div>
      </div>
    </div> </layout
></template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

//components
import Layout from "@/layouts/Layout";

//mixins
import withNavigate from "@/mixins/withNavigate";

//assets
import arrow from "@/assets/images/arrow-right-gray.svg";
import arrowPrimary from "@/assets/images/arrow-right-primary.svg";
import problemIcon from "@/assets/images/support-problem.svg";
import questionIcon from "@/assets/images/support-question.svg";

export default Vue.component("Support", {
  components: { Layout },

  mixins: [withNavigate],

  data() {
    return {
      arrow,
      arrowPrimary,
      submitBtnHovered: false,
      reportTypes: [
        {
          image: problemIcon,
          key: "problem",
          title: "Report an issue",
          description:
            "Raise an issue about a product feature, connectivity, or specific functionality"
        },
        {
          image: questionIcon,
          key: "question",
          title: "Ask a product or question",
          description:
            "Get support for product functionality, integrating with Inkit,\n" +
            "or any other questions."
        }
      ]
    };
  },

  methods: {
    chooseArrow(typeKey) {
      return this.submitBtnHovered === typeKey ? this.arrowPrimary : this.arrow;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "support";

.#{$ns} {
  color: #1f1f1f;
  padding: 80px 40px;

  h1 {
    text-align: center;
  }
}

.title {
  font-size: 26px;
  font-family: Lato-Bold, Arial, sans-serif;
}

.description {
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  white-space: pre-wrap;
}

.submitBtn {
  text-align: right;
  color: $secondary-grey;
  cursor: pointer;
  width: fit-content;
  justify-self: end;
  :first-child {
    margin-right: 22px;
  }

  &.hovered {
    color: $primary-color;
  }
}

.#{$ns}__types {
  margin-top: 30px;
  display: grid;
  grid-gap: 30px;
  grid-auto-rows: 250px;
  grid-template-columns: repeat(auto-fit, 500px);
  justify-content: center;
  line-height: 1em;

  .type-item {
    cursor: pointer;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 30px;
    display: grid;
    grid-gap: 15px;
    align-items: center;
    line-height: 1.4;

    &.hovered {
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
